import React from 'react';

export const BZHeaderKorea = () => {
  return (
    <>
      <link
        as="font"
        crossOrigin="anonymous"
        href="/next-assets/fonts/noto-sans-kr/NotoSans-Black.woff2"
        rel="preload"
        type="font/woff2"
      />
      <link
        as="font"
        crossOrigin="anonymous"
        href="/next-assets/fonts/noto-sans-kr/NotoSans-Bold.woff2"
        rel="preload"
        type="font/woff2"
      />
      <link
        as="font"
        crossOrigin="anonymous"
        href="/next-assets/fonts/noto-sans-kr/NotoSansKR-ExtraBold.ttf"
        rel="preload"
        type="font/ttf"
      />
      <link
        as="font"
        crossOrigin="anonymous"
        href="/next-assets/fonts/noto-sans-kr/NotoSansKR-ExtraLight.ttf"
        rel="preload"
        type="font/ttf"
      />
      <link
        as="font"
        crossOrigin="anonymous"
        href="/next-assets/fonts/noto-sans-kr/NotoSans-Light.woff2"
        rel="preload"
        type="font/woff2"
      />
      <link
        as="font"
        crossOrigin="anonymous"
        href="/next-assets/fonts/noto-sans-kr/NotoSans-Medium.woff2"
        rel="preload"
        type="font/woff2"
      />
      <link
        as="font"
        crossOrigin="anonymous"
        href="/next-assets/fonts/noto-sans-kr/NotoSans-Regular.woff2"
        rel="preload"
        type="font/woff2"
      />
      <link
        as="font"
        crossOrigin="anonymous"
        href="/next-assets/fonts/noto-sans-kr/NotoSansKR-SemiBold.ttf"
        rel="preload"
        type="font/ttf"
      />
      <link
        as="font"
        crossOrigin="anonymous"
        href="/next-assets/fonts/noto-sans-kr/NotoSans-Thin.woff2"
        rel="preload"
        type="font/woff2"
      />
    </>
  );
};
